class ErrorHandle {

  static ReqX(){
    
  }

}

export default ErrorHandle;